var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chat-container" }, [
    _vm.hasMessage
      ? _c(
          "div",
          {
            class: [
              "chat-container__chat-message-wrapper",
              {
                "chat-message--user": _vm.roleLabel === "user",
                "chat-message--error": _vm.roleLabel === "system-error"
              }
            ]
          },
          [
            _c("div", { staticClass: "chat-container__chat-message" }, [
              _vm.isAssistent
                ? _c("i", { staticClass: "icon icon-vue" })
                : _vm._e(),
              _c("span", { staticClass: "chat-container__error-icon" }, [
                _vm.isAnErrorSystem
                  ? _c("i", { staticClass: "icon icon-warning" })
                  : _vm._e()
              ]),
              _c(
                "div",
                {
                  staticClass: "chat-message__text-container",
                  on: {
                    mouseover: function($event) {
                      _vm.showCopyIcon = true
                    },
                    mouseleave: function($event) {
                      _vm.showCopyIcon = false
                    }
                  }
                },
                [
                  !_vm.message.isLoading
                    ? _c("p", {
                        staticClass: "chat-message__text",
                        domProps: { innerHTML: _vm._s(_vm.renderedContent) }
                      })
                    : _c("Spinner", { staticClass: "chat-message__text" }),
                  _vm.showCopyIcon && _vm.isAssistent
                    ? _c("i", {
                        staticClass: "icon icon-copy",
                        on: { click: _vm.copyToClipboard }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _c("p", { staticClass: "chat-container__time" }, [
              _vm._v(_vm._s(_vm.formattedTime))
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }